export default __webpack_public_path__ + "static/media/dewali-promo.458a6e61.webp";